import { render, staticRenderFns } from "./load-board-card.vue?vue&type=template&id=05fcd84c"
import script from "./load-board-card.vue?vue&type=script&lang=js"
export * from "./load-board-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports